var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAldoShoes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 35,
    viewBox: "0 0 187 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7295 34.2371V0.744507H54.3799V28.6675H81.8008V34.2371H48.7295Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.661 28.656C122.849 28.6098 127.31 23.1384 127.328 17.5745V17.4995C127.258 12.1608 123.184 6.37762 110.832 6.33722H94.3082V28.656H109.655M109.378 34.2314H88.6982V0.756074H110.832C127.703 0.721445 133.024 10.3658 133.036 17.5341V17.6034C133.036 21.3953 131.604 25.5797 127.905 28.7945C124.205 32.0093 118.289 34.2314 109.389 34.2314",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.135 29.3832C175.532 29.3602 181.315 23.4212 181.332 17.4995C181.315 11.4624 175.417 5.63309 163.135 5.61577C150.737 5.63886 144.954 11.5836 144.937 17.4995C144.948 23.4212 150.731 29.3602 163.135 29.3832ZM163.135 0C171.157 0 177.119 2.15858 181.09 5.44262C185.055 8.72089 187.006 13.1189 187 17.4995C187 21.8744 185.049 26.2781 181.09 29.5564C177.125 32.8347 171.163 34.999 163.146 34.999H163.135C155.112 34.999 149.15 32.8404 145.179 29.5564C141.214 26.2781 139.263 21.8802 139.263 17.4995C139.263 13.1189 141.208 8.72089 145.179 5.44262C149.15 2.15858 155.112 0 163.135 0Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0119 20.5757H28.5521L21.8455 10.083L15.0119 20.5757ZM0.854198 34.214H0L21.8686 0.0865479L43.6968 34.2198H37.3769L31.9689 26.1396H11.6413L6.33145 34.2314L0.854198 34.2198V34.214Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 34.9932,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAldoShoes);
export default __webpack_public_path__ + "static/media/AldoShoes.c94928a4db7a81564cb3d82fcccb101c.svg";
export { ForwardRef as ReactComponent };